import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-112">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="bg-brand-green/10 border-2 border-brand-green/50 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-113">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-64 h-64 bg-brand-green/20 blur-[80px] rounded-full -z-10" data-id="element-114" />

        <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-brand-green/20 mb-6" data-id="element-115">
          <ShieldCheck className="w-10 h-10 text-brand-green" data-id="element-116" />
        </div>

        <h2 className="text-3xl md:text-4xl font-bold text-white mb-8" data-id="element-117">
          🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
        </h2>

        <div className="space-y-4 text-lg text-gray-200 mb-8 max-w-2xl mx-auto" data-id="element-118">
          <p data-id="element-119">Abrís los tomos.</p>
          <p data-id="element-120">Usás los prompts en tu negocio.</p>
          <p className="font-bold text-white mt-6 mb-4" data-id="element-121">
            Si en 7 días no es lo que esperabas:
          </p>
          <ul className="space-y-2 text-left inline-block" data-id="element-122">
            <li className="flex items-center gap-2" data-id="element-123">
              <span className="text-brand-green" data-id="element-124">→</span> Devolución del 100%
            </li>
            <li className="flex items-center gap-2" data-id="element-125">
              <span className="text-brand-green" data-id="element-126">→</span> Sin formularios
            </li>
            <li className="flex items-center gap-2" data-id="element-127">
              <span className="text-brand-green" data-id="element-128">→</span> Sin drama
            </li>
            <li className="flex items-center gap-2" data-id="element-129">
              <span className="text-brand-green" data-id="element-130">→</span> Sin preguntas
            </li>
          </ul>
          <p className="text-sm text-brand-green font-bold mt-6" data-id="element-131">
            Tasa de devoluciones: menos del 1%.
          </p>
        </div>

        <div className="bg-black/20 p-6 rounded-xl border border-white/5 italic text-gray-300" data-id="element-132">
          💬 "La garantía existe porque confiamos en el producto. Si no te
          sirve, no nos merecemos tu plata." <br data-id="element-133" />
          <span className="text-brand-green font-bold not-italic mt-2 block" data-id="element-134">
            — Equipo AURA BIT
          </span>
        </div>
      </motion.div>
    </section>;
}